<div class="wrapper">
	<input [type]="show ? 'text' : 'password'" name="pw" [(ngModel)]="pw" (ngModelChange)="propagate()" />
	<div class="toggle-show" (click)="show = !show">
		<i [hidden]="show" class="fa fa-eye"></i>
		<i [hidden]="!show" class="fa fa-eye-slash"></i>
	</div>
</div>
